import React from "react";

type VisibilityProps = {
  visible: boolean;
  children: React.ReactNode;
};

const Visibility: React.FC<VisibilityProps> = ({ visible, children }) => {
  return visible ? <>{children}</> : null;
};

export default Visibility;
